import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {


  isLoading = new BehaviorSubject<boolean>(false);


  show() {
    this.isLoading.next(true)
  }
  dismiss() {
    this.isLoading.next(false)
  }

}
